export default __webpack_public_path__ + "static/media/protiv-logo.3820ed77.svg";